import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

const CustomExpandIcon = ({ expanded, onExpand, record }) =>
  expanded ? <MinusOutlined onClick={e => onExpand(record, e)} /> : <PlusOutlined onClick={e => onExpand(record, e)} />;

export default CustomExpandIcon;
